var map = {
	"./face-line.svg": 726,
	"./flower.svg": 105,
	"./home-hero-bg.jpg": 573,
	"./le-fayce-logo.svg": 250,
	"./molly-1.jpg": 412,
	"./molly-2.jpg": 859,
	"./products.png": 871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 225;